<template>
  <b-container fluid class='header'>
    <b-jumbotron fluid class='pt-1 jumbotron-overlay'>
      <b-container>
        <h1 class='text-white d-inline'>{{collection | capitalise | pluralise}}</h1>
      </b-container>
    </b-jumbotron>

    <b-container class="main py-4 rounded">

      <b-card-group deck>
        <b-card class="mb-4 text-center text-primary" @click="$router.push({name: 'site_create'})">
          <h1 class="mt-4">+</h1>
          <b-card-text>Add project</b-card-text>
        </b-card>

        <b-card  v-for="item of items" :key="item.id" :title="item.name" class="mb-4" footer-bg-variant="transparent" footer-border-variant="l" @click="$router.push({name: 'site', params: {site_id: item.id}})">
          <b-card-text>{{item.domain}}</b-card-text>
          <template v-slot:footer>
            <small class="text-muted"><i class="fas fa-globe"></i></small>

            <span class="float-right" v-if="days_left(item) <= 0"><b-badge variant="danger">Expired</b-badge></span>
            <span class="float-right" v-else-if="days_left(item) > 0"><b-badge variant="warning">Trial</b-badge></span>
            <small class="text-muted float-right" v-else>{{item.created | date}}</small>

            {{item.created | date}}
          </template>
        </b-card>
      </b-card-group>
    </b-container>
  </b-container>
</template>

<script>

import { db } from '@/main.js'
import ItemMixin from '@/mixins/Item.js'
import moment from 'moment'

export default {
  name: 'sites',
  mixins: [ItemMixin],
  props: ['profile'],
  firestore: function () {
    return {
      items: db.collection(this.collection).orderBy('created', 'desc').where('user', '==', this.profile.id)
    }
  },
  data() {
    return {
      items: [],
      collection: 'site'
    }
  },
  methods: {
    days_left(item) {
      if (item.trial_end) {
        return moment(item.trial_end.toDate()).diff(moment(), 'days')
      }

      return undefined
    }
  },
  metaInfo() {
    return {
      title: `${this.collection}s`
    };
  },
}
</script>

<style scoped>

.card {
  min-width: 16rem;
  max-width: 16rem;
  min-height: 10rem;
}

.card:hover {
  background: #EFEFEF;
  cursor: pointer;
}

</style>
